/**
 * NOTHING INTERRUPTS LEARNING, applied to entitlements (Tom's HARD RULE,
 * 2026-09-22; job #860).
 *
 * The entitlement list is re-fetched at boot, on sign-in, at a wall and on a
 * Play-as-class launch. An answer that ADDS access is applied at once. An
 * answer that TAKES access away is held for the rest of the app session once a
 * lesson has made a sound, and lands at the next app start instead: the
 * fresh answer is still written to the cache, so the next boot reads it.
 *
 * The case that asked for it: a pupil's class code stopped granting their
 * class's course (school free trial = play-as-class only, Tom 2026-09-29).
 * Without the hold, a pupil who pressed play before the boot fetch landed
 * would meet the wall at the next round boundary, mid-lesson.
 *
 * `baseline` is what the learner held last session, read from the cache
 * whatever its age, because the boot fetch can land after the first sound.
 */
import type { UserEntitlement } from '@ssi/core'

const keyOf = (e: UserEntitlement) =>
  JSON.stringify([e.accessType, e.grantedCourses ? [...e.grantedCourses].sort() : null, e.expiresAt ?? null])

export function entitlementsToApply(opts: {
  applied: UserEntitlement[]
  baseline: UserEntitlement[]
  fresh: UserEntitlement[]
  lessonStarted: boolean
}): UserEntitlement[] {
  if (!opts.lessonStarted) return opts.fresh
  const out = [...opts.fresh]
  const seen = new Set(out.map(keyOf))
  for (const e of [...opts.applied, ...opts.baseline]) {
    const k = keyOf(e)
    if (seen.has(k)) continue
    seen.add(k)
    out.push(e)
  }
  return out
}
